var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row mobile-row-nogutters"},[_c('div',{staticClass:"col-12 col-md-6 col-xl-4 col-xl2-3"},[_c('crane-card',{attrs:{"id":_vm.$route.params.id,"device-id":_vm.deviceId}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }